import {ENDPOINT_CONFIGURATION} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

// path to config in folder/s3 /fo/<foId>/<configType>/<configId>
const getConfiguration = (token, entityType, entityId, configType, configId) => {
  return fetch(
    `${ENDPOINT_CONFIGURATION}configs/${entityType}/${entityId}/${configType}/${configId}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getConfigurationWithParams = (
  token,
  entityType,
  entityId,
  configType,
  configId,
  params
) => {
  return fetch(
    `${ENDPOINT_CONFIGURATION}configs/${entityType}/${entityId}/${configType}/${configId}?${params}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getAllWhitelist = () => {
  return fetch(`${ENDPOINT_CONFIGURATION}whitelists`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const createWhitelist = (body) => {
  return fetch(`${ENDPOINT_CONFIGURATION}whitelists`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
};

const updateWhitelist = (whitelistId, body) => {
  return fetch(`${ENDPOINT_CONFIGURATION}whitelists/${whitelistId}`, {
    method: 'PUT',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
};

const deleteWhitelist = (whitelistId) => {
  return fetch(`${ENDPOINT_CONFIGURATION}whitelists/${whitelistId}`, {
    method: 'DELETE',
    headers: commonJwtHeader(),
  });
};

export default {
  getConfiguration,
  getConfigurationWithParams,
  getAllWhitelist,
  createWhitelist,
  updateWhitelist,
  deleteWhitelist,
};
